import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  loading: boolean;
  accountType: string | null;
  country: string | null;
  user: any;
  data: any;
}

interface LoginPayload {
  token: string | null;
  user: any;
  isAuthenticated: boolean;
  accountType: string | null;
  data: any;
}

const initialState: AuthState = {
  isAuthenticated: false,
  token: null,
  loading: true,
  accountType: null,
  country: null,
  user: null,
  data: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action: PayloadAction<LoginPayload>) => {
      state.isAuthenticated = action.payload.isAuthenticated;
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.accountType = action.payload.accountType;
      state.data = action.payload.data;
      state.loading = false;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      state.accountType = null;
      state.loading = false;
      state.data = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { loginSuccess, logout, setLoading } = authSlice.actions;
export default authSlice.reducer;
